import { fileViewerAtom } from 'js/file_viewer/core/atoms/atom';
import { activeEditorIdAtom, editorActivationParamsAtom } from 'js/file_viewer/core/atoms/editing';
import { AI_PLUGIN_ID } from 'js/file_viewer/core/data/types';
import { UserActionContext } from 'js/file_viewer/core/logging/constants';
export const sidebarWillAutoOpenAtom = fileViewerAtom(false);
const updateSidebarWillAutoOpenAtom = fileViewerAtom(false, (_get, set, actionContext) => {
    const sidebarWillAutoOpen = !!actionContext &&
        [
            UserActionContext.UserPreference,
            UserActionContext.Initialization,
            UserActionContext.LoggedOutCommenting,
            UserActionContext.UnreadComments,
        ].includes(actionContext);
    set(sidebarWillAutoOpenAtom, sidebarWillAutoOpen);
});
export const activeTextHighlighterIdAtom = fileViewerAtom(undefined, (_get, set, textHighlighterId) => {
    set(activeTextHighlighterIdAtom, textHighlighterId);
    set(activeEditorIdAtom, undefined);
    set(editorActivationParamsAtom, undefined);
});
export const leftSidebarIdAtom = fileViewerAtom(undefined, (_get, set, sidebarId, extra) => {
    set(leftSidebarIdAtom, sidebarId, extra);
    set(activeTextHighlighterIdAtom, undefined);
    set(updateSidebarWillAutoOpenAtom, extra === null || extra === void 0 ? void 0 : extra.actionContext);
});
export const shouldSaveRightSidebarPreferenceAtom = fileViewerAtom((get) => {
    const sidebarIdAndContext = get(rightSidebarIdAndUserActionContextPairAtom);
    const sidebarId = sidebarIdAndContext === null || sidebarIdAndContext === void 0 ? void 0 : sidebarIdAndContext.sidebarId;
    const actionContext = sidebarIdAndContext === null || sidebarIdAndContext === void 0 ? void 0 : sidebarIdAndContext.actionContext;
    return (sidebarId !== AI_PLUGIN_ID &&
        actionContext !== UserActionContext.UnreadComments &&
        actionContext !== UserActionContext.LoggedOutCommenting);
});
const rightSidebarIdAndUserActionContextPairAtom = fileViewerAtom(undefined);
export const rightSidebarIdAtom = fileViewerAtom((get) => {
    const pair = get(rightSidebarIdAndUserActionContextPairAtom);
    return pair === null || pair === void 0 ? void 0 : pair.sidebarId;
}, (_get, set, sidebarId, extra) => {
    set(rightSidebarIdAndUserActionContextPairAtom, {
        sidebarId,
        actionContext: extra === null || extra === void 0 ? void 0 : extra.actionContext,
    });
    set(activeTextHighlighterIdAtom, undefined);
    set(updateSidebarWillAutoOpenAtom, extra === null || extra === void 0 ? void 0 : extra.actionContext);
});
//# sourceMappingURL=plugins.preenvesnextjs.map
